import { Image } from './Image';
import { Metadata } from './Metadata';
import { Product } from './Product';

export class Category {
    id: number;
    name: string;
    description: string;
    metadata: Array<Metadata>;
    containsalcohol: boolean;
    images: Array<Image> | null;
    products: Array<Product>;
}
